import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { personnelToWarehouseAccess, PersonnelToWarehouseAccessViewModel } from "./personnelToWarehouseAccess-viewModel"

export class PersonnelToWarehouseAccessView extends View<PersonnelToWarehouseAccessViewModel>{
    GetViewUniqueId(): string {
        return "V-67C642C6-7B66-436D-B64C-D9BEA9ED6A0B"
    }
    loadHtml(): string {
        let element = require('./personnelToWarehouseAccess.html').default;
        let style = require('./personnelToWarehouseAccess.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouses(v: ObservableArray<personnelToWarehouseAccess>) { this._warehouses = v; } public get warehouses(): ObservableArray<personnelToWarehouseAccess> { return this._warehouses;} private _warehouses: ObservableArray<personnelToWarehouseAccess>;
    public set personnels(v: ObservableArray<personnelToWarehouseAccess>) { this._personnels = v; } public get personnels(): ObservableArray<personnelToWarehouseAccess> { return this._personnels;} private _personnels: ObservableArray<personnelToWarehouseAccess>;
    public set personnelToWarehouseAccess(v: ObservableArray<personnelToWarehouseAccess>) { this._personnelToWarehouseAccess = v; } public get personnelToWarehouseAccess(): ObservableArray<personnelToWarehouseAccess> { return this._personnelToWarehouseAccess;} private _personnelToWarehouseAccess: ObservableArray<personnelToWarehouseAccess>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set activeObject(v: boolean) { this._activeObject = v; } public get activeObject(): boolean { return this._activeObject;} private _activeObject: boolean;
    
    save(){
        this.dataContext.save();
    }

    refresh() {
        this.dataContext.refresh();
    }
    
}
